module.exports = new __parcel__URL__("activeRoles.beaca07b.svg").toString();